export default __webpack_public_path__ + "static/media/PlayButton.71db205c.svg";